(function() {
  if (window.__milfiosFreeShippingHintInit) return;
  window.__milfiosFreeShippingHintInit = true;

  var RULES = [
    {
      name: 'Sudeste',
      ranges: [[1000, 39999]],
      minimum: 55000
    },
    {
      name: 'Sul e Centro-Oeste',
      ranges: [[70000, 76799], [78000, 99999]],
      minimum: 65000
    },
    {
      name: 'Norte e Nordeste',
      ranges: [[40000, 69999], [76800, 77999]],
      minimum: 80000
    }
  ];

  var lastQuote = null;
  var observer = null;
  var cartRefreshTimer = null;
  var sortPickupRatesTimer = null;

  function installStyles() {
    if (document.getElementById('milfios-free-shipping-hint-styles')) return;

    var style = document.createElement('style');
    style.id = 'milfios-free-shipping-hint-styles';
    style.textContent = [
      '.milfios-free-shipping-hint {',
      '  margin-block-start: 14px;',
      '  margin-block-end: 14px;',
      '  padding: 12px 14px;',
      '  border: 1px solid rgba(0, 0, 0, 0.1);',
      '  border-radius: 10px;',
      '  background: #fff8d8;',
      '  color: #2f2f2f;',
      '  display: block;',
      '  flex: 0 0 auto;',
      '  min-height: 0;',
      '  max-height: none;',
      '  font-family: Inter, var(--font-body--family), sans-serif;',
      '  font-size: 0.92rem;',
      '  line-height: 1.35;',
      '}',
      '.cart-page > .milfios-free-shipping-hint {',
      '  grid-column: 1;',
      '  width: 100%;',
      '  margin-block: 14px;',
      '}',
      '@media screen and (min-width: 750px) {',
      '  .cart-page > .milfios-free-shipping-hint {',
      '    margin-block: 0 14px;',
      '  }',
      '}',
      '.product-information .milfios-free-shipping-hint {',
      '  width: 100%;',
      '  margin-block: 0 12px;',
      '}',
      '.product-information :is([id*="cota" i], [class*="cota" i], [id*="kokfy" i], [class*="kokfy" i], [id*="frete" i], [class*="frete" i], [id*="shipping" i], [class*="shipping" i]) input,',
      '.product-information form:has(input[placeholder*="CEP" i]) input,',
      '.product-information form:has(input[name*="cep" i]) input,',
      '.product-information form:has(input[id*="cep" i]) input {',
      '  border: 1px solid #000000 !important;',
      '  color: #000000 !important;',
      '  background: #ffffff !important;',
      '  box-shadow: none !important;',
      '}',
      '.product-information :is([id*="cota" i], [class*="cota" i], [id*="kokfy" i], [class*="kokfy" i], [id*="frete" i], [class*="frete" i], [id*="shipping" i], [class*="shipping" i]) button,',
      '.product-information form:has(input[placeholder*="CEP" i]) button,',
      '.product-information form:has(input[name*="cep" i]) button,',
      '.product-information form:has(input[id*="cep" i]) button {',
      '  border: 1px solid #000000 !important;',
      '  background: #ffffff !important;',
      '  color: #000000 !important;',
      '  box-shadow: none !important;',
      '}',
      '.product-information :is([id*="cota" i], [class*="cota" i], [id*="kokfy" i], [class*="kokfy" i], [id*="frete" i], [class*="frete" i], [id*="shipping" i], [class*="shipping" i]) button:hover,',
      '.product-information form:has(input[placeholder*="CEP" i]) button:hover,',
      '.product-information form:has(input[name*="cep" i]) button:hover,',
      '.product-information form:has(input[id*="cep" i]) button:hover {',
      '  color: #777777 !important;',
      '  background: #ffffff !important;',
      '  border-color: #000000 !important;',
      '}',
      '.product-information :is([id*="cota" i], [class*="cota" i], [id*="kokfy" i], [class*="kokfy" i], [id*="frete" i], [class*="frete" i], [id*="shipping" i], [class*="shipping" i]),',
      '.product-information :is([id*="cota" i], [class*="cota" i], [id*="kokfy" i], [class*="kokfy" i], [id*="frete" i], [class*="frete" i], [id*="shipping" i], [class*="shipping" i]) * {',
      '  color: #000000;',
      '}',
      '.milfios-free-shipping-hint strong {',
      '  font-weight: 800;',
      '}'
    ].join('');

    document.head.appendChild(style);
  }

  function onlyDigits(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function formatMoney(cents) {
    return (Math.max(0, cents) / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  function getCepPrefix(cep) {
    var digits = onlyDigits(cep);
    if (digits.length < 5) return null;
    return parseInt(digits.slice(0, 5), 10);
  }

  function findRule(cep) {
    var prefix = getCepPrefix(cep);
    if (prefix === null || Number.isNaN(prefix)) return null;

    for (var i = 0; i < RULES.length; i++) {
      var rule = RULES[i];
      for (var j = 0; j < rule.ranges.length; j++) {
        var range = rule.ranges[j];
        if (prefix >= range[0] && prefix <= range[1]) return rule;
      }
    }

    return null;
  }

  function getParam(searchParams, names) {
    for (var i = 0; i < names.length; i++) {
      var value = searchParams.get(names[i]);
      if (value !== null && value !== '') return value;
    }

    return '';
  }

  function getActiveCep() {
    var active = document.activeElement;
    if (active && active.matches && active.matches('input')) {
      var activeText = [
        active.name,
        active.id,
        active.placeholder,
        active.getAttribute('aria-label')
      ].join(' ');

      if (/cep|zip|postal/i.test(activeText)) return active.value;
    }

    var fields = document.querySelectorAll(
      'input[placeholder*="CEP" i], input[name*="cep" i], input[id*="cep" i], input[aria-label*="CEP" i], input[name*="zip" i], input[id*="zip" i], input[name*="postal" i], input[id*="postal" i]'
    );

    for (var i = 0; i < fields.length; i++) {
      if (onlyDigits(fields[i].value).length >= 8) return fields[i].value;
    }

    return '';
  }

  function getQuoteFromUrl(url) {
    try {
      var urlObj = new URL(String(url), window.location.origin);
      if (!urlObj.pathname.includes('/apps/cotafrete/get_rates')) return null;

      var cep = getParam(urlObj.searchParams, [
        'cep',
        'zip',
        'zipcode',
        'zip_code',
        'postal_code',
        'destination_zip',
        'destination_postal_code'
      ]) || getActiveCep();

      var totalValue = getParam(urlObj.searchParams, [
        'total_value',
        'subtotal',
        'cart_total',
        'value',
        'price'
      ]);

      var totalCents = parseInt(onlyDigits(totalValue), 10);
      if (!totalCents || Number.isNaN(totalCents)) totalCents = getCartTotalFromPage();

      return {
        cep: onlyDigits(cep),
        totalCents: totalCents || 0,
        time: Date.now()
      };
    } catch (e) {
      return null;
    }
  }

  function getCartTotalFromPage() {
    var total = document.querySelector('[data-cart-subtotal], [data-testid="cart-total-value"]');
    if (!total) return 0;

    var text = total.textContent || '';
    var match = text.match(/(\d[\d.]*,\d{2})/);
    if (!match) return 0;

    return parseInt(match[1].replace(/\D/g, ''), 10) || 0;
  }

  function normalizeText(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function isPickupRateElement(element) {
    var text = normalizeText(element && element.textContent);

    return (
      text.indexOf('retirar na loja') !== -1 ||
      text.indexOf('retirada na loja') !== -1 ||
      text.indexOf('retire na loja') !== -1 ||
      text.indexOf('retira na loja') !== -1
    );
  }

  function getOwnText(element) {
    if (!element) return '';

    return Array.prototype.slice.call(element.childNodes).map(function(node) {
      return node.nodeType === Node.TEXT_NODE ? node.textContent : '';
    }).join(' ');
  }

  function isPickupRateTitle(element) {
    var text = normalizeText(getOwnText(element) || (element && element.textContent));

    return (
      text.indexOf('retirar na loja') !== -1 ||
      text.indexOf('retirada na loja') !== -1 ||
      text.indexOf('retire na loja') !== -1 ||
      text.indexOf('retira na loja') !== -1
    );
  }

  function isCarrierRateElement(element) {
    if (!element || element.matches('script, style, template')) return false;
    if (element.querySelector('input[placeholder*="CEP" i], input[name*="cep" i], input[id*="cep" i]')) return false;

    var text = normalizeText(element.textContent);
    if (!text) return false;

    return /\b(pac|sedex|jadlog|loggi)\b/.test(text) ||
      text.indexOf('transportadora') !== -1 ||
      text.indexOf('correios') !== -1;
  }

  function getRateStopElement(parent) {
    var children = Array.prototype.slice.call(parent.children);

    for (var i = 0; i < children.length; i++) {
      var text = normalizeText(children[i].textContent);
      if (text === 'desconto' || text.indexOf('cupom') !== -1) return children[i];
    }

    return null;
  }

  function restorePickupRateTextOrder(title) {
    var previous = title && title.previousElementSibling;
    if (!previous) return;

    var previousText = normalizeText(previous.textContent);
    if (previousText.indexOf('polo textil') !== -1 || previousText.indexOf('dias uteis') !== -1) {
      title.parentElement.insertBefore(title, previous);
    }
  }

  function getFlatPickupGroup(title) {
    var parent = title.parentElement;
    if (!parent) return null;

    var siblings = Array.prototype.slice.call(parent.children);
    if (!siblings.some(isCarrierRateElement)) return null;

    var startIndex = siblings.indexOf(title);
    if (startIndex === -1) return null;

    var nodes = [title];
    for (var i = startIndex + 1; i < siblings.length; i++) {
      if (isCarrierRateElement(siblings[i]) || isPickupRateTitle(siblings[i]) || normalizeText(siblings[i].textContent) === 'desconto') break;
      nodes.push(siblings[i]);
    }

    return {
      parent: parent,
      nodes: nodes,
      before: getRateStopElement(parent)
    };
  }

  function getPickupRateMove(element, root) {
    var current = element;

    while (current && current !== root && current !== document.body) {
      var parent = current.parentElement;
      if (!parent) break;

      var siblings = Array.prototype.slice.call(parent.children);
      var carrierSiblings = siblings.filter(isCarrierRateElement);

      if (carrierSiblings.length > 0 && siblings.indexOf(current) !== -1 && isPickupRateElement(current)) {
        return {
          parent: parent,
          row: current,
          before: getRateStopElement(parent)
        };
      }

      current = parent;
    }

    return null;
  }

  function getShippingRoots() {
    var roots = [];
    var selectors = [
      '[data-milfios-cart-shipping-slot]',
      '[data-milfios-shipping-relocated]',
      '[id*="cota" i]',
      '[class*="cota" i]',
      '[id*="kokfy" i]',
      '[class*="kokfy" i]',
      '[id*="frete" i]',
      '[class*="frete" i]',
      '[id*="shipping" i]',
      '[class*="shipping" i]'
    ];

    document.querySelectorAll(selectors.join(',')).forEach(function(root) {
      if (!root || roots.indexOf(root) !== -1) return;
      if (!/retir|pac|sedex|jadlog|entrega|frete/i.test(root.textContent || '')) return;
      roots.push(root);
    });

    return roots;
  }

  function sortPickupRates() {
    var roots = getShippingRoots();

    roots.forEach(function(root) {
      var pickupNodes = Array.prototype.slice.call(root.querySelectorAll('*')).filter(function(element) {
        return isPickupRateTitle(element) && !Array.prototype.some.call(element.children, isPickupRateTitle);
      });

      pickupNodes.forEach(function(node) {
        restorePickupRateTextOrder(node);

        var flatGroup = getFlatPickupGroup(node);
        if (flatGroup && flatGroup.nodes.length > 1) {
          flatGroup.nodes.forEach(function(groupNode) {
            flatGroup.parent.insertBefore(groupNode, flatGroup.before);
          });
          return;
        }

        var move = getPickupRateMove(node, root);
        if (!move) return;

        move.parent.insertBefore(move.row, move.before);
      });
    });
  }

  function scheduleSortPickupRates() {
    window.clearTimeout(sortPickupRatesTimer);
    sortPickupRatesTimer = window.setTimeout(function() {
      sortPickupRates();
    }, 80);

    window.setTimeout(sortPickupRates, 350);
    window.setTimeout(sortPickupRates, 900);
  }

  function refreshQuoteFromCart() {
    if (!lastQuote || !lastQuote.cep) return;

    window.clearTimeout(cartRefreshTimer);
    cartRefreshTimer = window.setTimeout(function() {
      fetch('/cart.js')
        .then(function(response) {
          return response.ok ? response.json() : null;
        })
        .then(function(cart) {
          if (!cart || !lastQuote || !lastQuote.cep) return;

          lastQuote.totalCents = cart.total_price || cart.items_subtotal_price || lastQuote.totalCents || 0;
          lastQuote.time = Date.now();
          scheduleRender();
        })
        .catch(function() {
          var pageTotal = getCartTotalFromPage();
          if (!pageTotal || !lastQuote) return;

          lastQuote.totalCents = pageTotal;
          lastQuote.time = Date.now();
          scheduleRender();
        });
    }, 250);
  }

  function isCartChangeUrl(url) {
    try {
      var urlObj = new URL(String(url), window.location.origin);
      return /\/cart\/(change|update|add|clear)(\.js)?$/.test(urlObj.pathname);
    } catch (e) {
      return false;
    }
  }

  function hasCepContent(element) {
    if (!element || element.closest('[data-milfios-free-shipping-hint]')) return false;

    var text = (element.textContent || '').toLowerCase();
    var hasCepText = text.indexOf('cep') !== -1 || text.indexOf('frete') !== -1 || text.indexOf('entrega') !== -1;
    var hasCepField = !!element.querySelector(
      'input[placeholder*="CEP" i], input[name*="cep" i], input[id*="cep" i], input[aria-label*="CEP" i], input[name*="zip" i], input[id*="zip" i], input[name*="postal" i], input[id*="postal" i]'
    );

    return hasCepText && hasCepField;
  }

  function getBoundedContainer(element) {
    if (window.location.pathname.indexOf('/products/') !== -1) {
      var productCurrent = element.parentElement;

      while (productCurrent && productCurrent !== document.body) {
        var productText = (productCurrent.textContent || '').toLowerCase();

        if (
          productText.indexOf('calcule') !== -1 &&
          productText.indexOf('frete') !== -1 &&
          !productCurrent.querySelector('h1') &&
          !productCurrent.matches('.product-details, .product-information, .product-information__grid')
        ) {
          return productCurrent;
        }

        if (
          productCurrent.matches('.product-information__grid, .product-information, .product-details, .shopify-section, main')
        ) {
          break;
        }

        productCurrent = productCurrent.parentElement;
      }

      return element.parentElement;
    }

    var preferred = element.closest(
      '[data-milfios-shipping-relocated], [id*="cota" i], [class*="cota" i], [id*="kokfy" i], [class*="kokfy" i], [id*="frete" i], [class*="frete" i], [id*="shipping" i], [class*="shipping" i], [data-app-block]'
    );

    if (preferred && hasCepContent(preferred)) return preferred;

    var current = element;
    var lastGood = null;

    while (current && current !== document.body) {
      if (current.matches('.shopify-section, main, form[action*="/cart"], .product-information')) break;
      if (hasCepContent(current)) lastGood = current;
      current = current.parentElement;
    }

    return lastGood;
  }

  function findCalculator(cep) {
    var fields = document.querySelectorAll(
      'input[placeholder*="CEP" i], input[name*="cep" i], input[id*="cep" i], input[aria-label*="CEP" i], input[name*="zip" i], input[id*="zip" i], input[name*="postal" i], input[id*="postal" i]'
    );

    for (var i = 0; i < fields.length; i++) {
      var fieldCep = onlyDigits(fields[i].value);
      if (cep && fieldCep.length >= 8 && fieldCep !== cep) continue;

      var container = getBoundedContainer(fields[i]);
      if (container) return container;
    }

    var candidates = document.querySelectorAll(
      '[data-milfios-shipping-relocated], [id*="cota" i], [class*="cota" i], [id*="kokfy" i], [class*="kokfy" i], [id*="frete" i], [class*="frete" i], [id*="shipping" i], [class*="shipping" i]'
    );

    for (var j = 0; j < candidates.length; j++) {
      if (hasCepContent(candidates[j])) return candidates[j];
    }

    return null;
  }

  function getHintAnchor(calculator) {
    var existing = calculator.querySelector('[data-milfios-free-shipping-hint]');
    if (existing) return existing;

    var form = calculator.querySelector(
      'form, .form, [class*="form" i], button'
    );
    if (form) {
      var formContainer = form.closest('form, .form, [class*="form" i]') || form.parentElement || form;
      if (calculator.contains(formContainer)) return formContainer;
    }

    var children = Array.prototype.slice.call(calculator.children);
    var best = null;

    for (var i = children.length - 1; i >= 0; i--) {
      var child = children[i];
      if (child.matches('script, style') || child.querySelector('[data-milfios-free-shipping-hint]')) continue;

      var text = (child.textContent || '').toLowerCase();
      if (/pac|sedex|jadlog|gratis|grátis|entrega|dias úteis/.test(text)) {
        best = child;
        break;
      }
    }

    return best || calculator.lastElementChild;
  }

  function getProductHintHost(calculator) {
    if (window.location.pathname.indexOf('/products/') === -1 || !calculator) return null;

    var host = calculator.parentElement;
    if (!host || host === document.body) host = calculator;

    return {
      root: host,
      insert: function(hint) {
        if (calculator.parentNode === host) {
          if (hint.parentNode !== host || hint.nextElementSibling !== calculator) {
            host.insertBefore(hint, calculator);
          }
        } else if (hint.parentNode !== calculator || hint !== calculator.firstElementChild) {
          calculator.insertBefore(hint, calculator.firstElementChild);
        }
      }
    };
  }

  function getCartHintHost(calculator) {
    if (window.location.pathname.replace(/\/$/, '') !== '/cart') return null;

    var cartPage = document.querySelector('.cart-page:not(.cart-page--empty)');
    var cartItems = cartPage ? cartPage.querySelector('.cart-page__items') : null;
    if (!cartPage || !cartItems) return null;

    return {
      root: cartPage,
      insert: function(hint) {
        if (window.matchMedia('(max-width: 749px)').matches) {
          if (hint.parentNode !== cartPage || hint.previousElementSibling !== cartItems) {
            cartItems.insertAdjacentElement('afterend', hint);
          }
        } else if (hint.parentNode !== cartPage || hint.nextElementSibling !== cartItems) {
          cartPage.insertBefore(hint, cartItems);
        }
      }
    };
  }

  function renderHint() {
    installStyles();

    if (!lastQuote || !lastQuote.cep || !lastQuote.totalCents) return;

    var rule = findRule(lastQuote.cep);
    var calculator = findCalculator(lastQuote.cep);
    var productHost = getProductHintHost(calculator);
    var cartHost = getCartHintHost(calculator);
    if (!rule || (!calculator && !cartHost && !productHost)) return;

    var difference = rule.minimum - lastQuote.totalCents;
    var existing = document.querySelector('[data-milfios-free-shipping-hint]');

    if (difference <= 0) {
      if (existing) existing.remove();
      return;
    }

    var hint = existing || document.createElement('div');
    hint.setAttribute('data-milfios-free-shipping-hint', '');
    hint.className = 'milfios-free-shipping-hint';
    hint.innerHTML = 'Comprando mais <strong>' + formatMoney(difference) + '</strong> você tem <strong>FRETE GRÁTIS!</strong>';

    if (productHost) {
      productHost.insert(hint);
      return;
    }

    if (cartHost) {
      cartHost.insert(hint);
      return;
    }

    if (!existing) {
      var anchor = getHintAnchor(calculator);
      if (anchor && anchor.parentNode === calculator) {
        anchor.insertAdjacentElement('afterend', hint);
      } else {
        calculator.appendChild(hint);
      }
    }
  }

  function scheduleRender() {
    window.setTimeout(renderHint, 100);
    window.setTimeout(renderHint, 500);
    window.setTimeout(renderHint, 1200);
    scheduleSortPickupRates();
  }

  function rememberQuoteFromUrl(url) {
    var quote = getQuoteFromUrl(url);
    if (!quote) return;

    lastQuote = quote;
    scheduleRender();
  }

  var originalFetch = window.fetch;
  window.fetch = function(resource, options) {
    var url = resource instanceof Request ? resource.url : resource;
    rememberQuoteFromUrl(url);
    return originalFetch.apply(this, arguments).then(function(response) {
      rememberQuoteFromUrl(response.url || url);
      if (isCartChangeUrl(url) || isCartChangeUrl(response.url)) refreshQuoteFromCart();
      scheduleRender();
      return response;
    });
  };

  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this.addEventListener('loadend', function() {
      rememberQuoteFromUrl(url);
      if (isCartChangeUrl(url)) refreshQuoteFromCart();
      scheduleRender();
    });
    rememberQuoteFromUrl(url);
    return originalOpen.apply(this, arguments);
  };

  observer = new MutationObserver(function() {
    scheduleSortPickupRates();
    if (lastQuote) window.requestAnimationFrame(renderHint);
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', scheduleRender);
  window.addEventListener('load', scheduleRender);
  document.addEventListener('cart:updated', refreshQuoteFromCart);
  document.addEventListener('shopify:section:load', refreshQuoteFromCart);
  document.addEventListener('change', function(event) {
    if (event.target && event.target.closest && event.target.closest('.cart-page')) refreshQuoteFromCart();
  });
  document.addEventListener('click', function(event) {
    if (
      event.target &&
      event.target.closest &&
      event.target.closest('.cart-page') &&
      event.target.closest('button, a, input[type="button"], input[type="submit"]')
    ) {
      refreshQuoteFromCart();
    }
  });
})();
